document.addEventListener('DOMContentLoaded', function () {
    devtricker_attachPerformlogoutOnLogoutClick();
});

function devtricker_attachPerformlogoutOnLogoutClick() {

    const logoutButton = devtricker_dom_get_logoutButton();

    if (logoutButton) {
        logoutButton.addEventListener('click', async function (e) {
            e.preventDefault();
            
            await devtricker_process_perform_logout();
        });
    }
}